

const data = {
  p1: {
    title: "企业智能体平台",
    subtitle: "开箱即用的数字员工智能体，助力企业AI进化",
    link: "https://aibeings-agent.xiaoice.com/home",
  },
  p2: {
    title: "产品优势"
  },
  p3: {
    img: "p3Img",
    title: "三步构建智能体 轻松赋能业务场景",
    list: [
      {
        title: "构建企业知识库",
        desc: "通过整合企业内部数据和外部信息，打造智能体的专业知识基础，确保智能体理解业务背景和用户需求",
        list: [
          "多源数据整合，支持结构化和非结构化内容接入",
          "高效知识检索，构建底层数据积木，提升智能体回答准确率",
          "精准数据统计，智能分析业务数据表，支持复杂数据统计与分析"
        ]
      },
      {
        title: "搭建工作流",
        desc: "通过可视化拖拽操作，让你直观构建灵活高效的AI应用和工作流，实现AI与业务系统的自动化交互",
        list: [
          "可视化拖拽操作，无需编写代码即可快速搭建复杂业务流程",
          "灵活配置各类节点，支持多样化业务场景和复杂交互需求",
          "多轮智能对话能力，实现自然流畅的交互体验"
        ]
      },
      {
        title: "发布智能体",
        desc: "通过多端发布功能一键部署智能体，快速实现多渠道覆盖，实时监控运行状态，保障系统高效稳定持续服务",
        list: [
          "企业不依赖于第三方服务提供商来访问关键业务应用。",
          "企业可以通过自主管理和优化来控制运营成本，实现更好的成本效益。",
          "企业可以根据自己的业务连续性计划来设计和实施灾难恢复策略。"
        ]
      }
    ]
  }
};
export default data;
